import { useState } from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const HardwareInfo = ({ hostname, updatedAt }) => {
  const [open, setOpen] = useState(false);
  const date = updatedAt ? new Date(updatedAt) : null;
  const dateText = date && !Number.isNaN(date.getTime())
    ? date.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
    : 'Fecha no disponible';

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Última actualización del hardware de ${hostname}: ${dateText}`}
          className="inline-flex shrink-0 rounded-sm text-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
          onPointerEnter={event => { if (event.pointerType === 'mouse') setOpen(true); }}
          onPointerLeave={event => { if (event.pointerType === 'mouse') setOpen(false); }}
        >
          <Info className="h-3.5 w-3.5" strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-auto max-w-64 px-3 py-2 text-xs"
        sideOffset={5}
        onOpenAutoFocus={event => event.preventDefault()}
        onCloseAutoFocus={event => event.preventDefault()}
      >
        <p>Última actualización del hardware:</p>
        <p className="mt-1 font-medium">{dateText}</p>
      </PopoverContent>
    </Popover>
  );
};

export default HardwareInfo;
